import { ISearchResult, useStore, IMaterialInventorySearchResult } from "../store";
import { IDateRange, IPeriodRange } from "../contracts";
import { ISelectItem } from "@react-gcc-eds/core";

export const useMetricsFiltersActions = () => {
  const [_, setState] = useStore();

  const setMetricsOverallOrderStatusBarsCreationRange = (range: IDateRange) => {
    setState(old => ({
      ...old,
      metricsFilters: {
        ...old.metricsFilters,
        overallOrderStatusBarsCreationRange: range
      }
    }));
  };

  const setMetricsShipmentStatusBarsDeliveredRange = (range: IDateRange) => {
    setState(old => ({
      ...old,
      metricsFilters: {
        ...old.metricsFilters,
        shipmentDeliveredRange: range
      }
    }));
  };

  const setMetricsOverallOrderStatusDonutCreationRange = (range: IDateRange) => {
    setState(old => ({
      ...old,
      metricsFilters: {
        ...old.metricsFilters,
        overallOrderStatusDonutCreationRange: range
      }
    }));
  };

  const setMetricsPlannedDeliveryItemsSearch = (search?: ISearchResult) => {
    setState(old => ({
      ...old,
      metricsFilters: {
        ...old.metricsFilters,
        plannedDeliveryItemsSearch: search
      }
    }));
  };

  const setMetricsShipmentCountCreationRange = (range: IDateRange) => {
    setState(old => ({
      ...old,
      metricsFilters: {
        ...old.metricsFilters,
        shipmentCountCreationRange: range
      }
    }));
  };

  const setMetricsOrderLeadTimeCreationRange = (range: IPeriodRange) => {
    setState(old => ({
      ...old,
      metricsFilters: {
        ...old.metricsFilters,
        orderLeadTimeCreationRange: range
      }
    }));
  };

  const setMetricsOrderAverageLeadTimeCreationRange = (range: IPeriodRange) => {
    setState(old => ({
      ...old,
      metricsFilters: {
        ...old.metricsFilters,
        orderAverageLeadTimeCreationRange: range
      }
    }));
  };

  const setMetricsDeliveryPrecisionCreationRange = (range: IDateRange) => {
    setState(old => ({
      ...old,
      metricsFilters: {
        ...old.metricsFilters,
        deliveryPrecisionCreationRange: range
      }
    }));
  };

  const setMetricsOverallInternalOrderStatusBarsCreationRange = (range: IDateRange) => {
    setState(old => ({
      ...old,
      metricsFilters: {
        ...old.metricsFilters,
        overallInternalOrderStatusBarsCreationRange: range
      }
    }));
  };

  const setMetricsOverallInternalOrderStatusDonutCreationRange = (range: IDateRange) => {
    setState(old => ({
      ...old,
      metricsFilters: {
        ...old.metricsFilters,
        overallInternalOrderStatusDonutCreationRange: range
      }
    }));
  };

  const setMetricsMaterialInventorySearch = (search?: IMaterialInventorySearchResult) => {
    setState(old => ({
      ...old,
      metricsFilters: {
        ...old.metricsFilters,
        materialInventorySearch: search
      }
    }));
  };

  const setMetricsOverallOrderStatusBarsOrderNumbers = (items: ISelectItem[]) => {
    const numbers: string[] = [];
    items.forEach(function (item) {
      numbers.push(item.value);
    });
    setState(old => ({
      ...old,
      metricsFilters: {
        ...old.metricsFilters,
        overallOrderStatusBarsItemsOrderNumbers: numbers
      }
    }));
  };

  const setMetricsOverallInternalOrderStatusBarsOrderNumbers = (items: ISelectItem[]) => {
    const numbers: string[] = [];
    items.forEach(function (item) {
      numbers.push(item.value);
    });
    setState(old => ({
      ...old,
      metricsFilters: {
        ...old.metricsFilters,
        overallInternalOrderStatusBarsItemsOrderNumbers: numbers
      }
    }));
  };

  const setMetricsOverallOrderStatusBarsOpCos = (items: ISelectItem[]) => {
    const uniqueValues = Array.from(
      new Set(items.map(item => JSON.stringify({ id: item.value, title: item.title })))
    ).map(item => JSON.parse(item));

    setState(old => ({
      ...old,
      metricsFilters: {
        ...old.metricsFilters,
        overallOrderStatusBarsOpCos: uniqueValues
      }
    }));
  };

  const setMetricsOverallOrderStatusBarsItemsOpCos = (items: ISelectItem[]) => {
    const uniqueValues = Array.from(
      new Set(items.map(item => JSON.stringify({ id: item.value, title: item.title })))
    ).map(item => JSON.parse(item));

    setState(old => ({
      ...old,
      metricsFilters: {
        ...old.metricsFilters,
        overallOrderStatusBarsItemsOpCos: uniqueValues
      }
    }));
  };

  return {
    setMetricsOverallOrderStatusBarsCreationRange,
    setMetricsShipmentStatusBarsDeliveredRange,
    setMetricsOverallOrderStatusDonutCreationRange,
    setMetricsPlannedDeliveryItemsSearch,
    setMetricsShipmentCountCreationRange,
    setMetricsOrderLeadTimeCreationRange,
    setMetricsOrderAverageLeadTimeCreationRange,
    setMetricsDeliveryPrecisionCreationRange,
    setMetricsOverallInternalOrderStatusDonutCreationRange,
    setMetricsOverallInternalOrderStatusBarsCreationRange,
    setMetricsMaterialInventorySearch,
    setMetricsOverallOrderStatusBarsOrderNumbers,
    setMetricsOverallInternalOrderStatusBarsOrderNumbers,
    setMetricsOverallOrderStatusBarsOpCos,
    setMetricsOverallOrderStatusBarsItemsOpCos
  };
};
